import { render, staticRenderFns } from "./QuestionnaireModal.vue?vue&type=template&id=64cb9908&scoped=true&"
import script from "./QuestionnaireModal.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireModal.vue?vue&type=style&index=0&id=64cb9908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb9908",
  null
  
)

export default component.exports